export default "__VITE_ASSET__B1zCyv8X__"